module.exports = __webpack_public_path__ + "img/chr_ts_90_26_2.791986cb.png";